import React from 'react';
import { MapPinIcon, PhoneIcon, ClockIcon } from 'lucide-react';
export function ContactInfo() {
  return <section id="contact" className="py-24 bg-brand-black border-t border-brand-gold/10 relative overflow-hidden" data-id="element-112">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-113">
        <div className="bg-brand-charcoal border border-brand-gold/20 rounded-sm p-8 md:p-16 shadow-lg" data-id="element-114">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-115">
            <div data-id="element-116">
              <h2 className="font-heading text-3xl md:text-4xl text-brand-white mb-6" data-id="element-117">
                Visit Deluxe MedSpa Beauty in Miami
              </h2>
              <p className="text-brand-champagne-light/70 mb-10 max-w-md" data-id="element-118">
                Experience luxury aesthetic care in our state-of-the-art Miami
                clinic. We look forward to welcoming you.
              </p>

              <div className="space-y-8" data-id="element-119">
                <div className="flex items-start" data-id="element-120">
                  <MapPinIcon className="w-6 h-6 text-brand-gold mr-4 flex-shrink-0 mt-1" data-id="element-121" />
                  <div data-id="element-122">
                    <h3 className="text-brand-white font-medium mb-1" data-id="element-123">
                      Location
                    </h3>
                    <address className="not-italic text-brand-champagne-light/70" data-id="element-124">
                      Deluxe MedSpa Beauty
                      <br data-id="element-125" />
                      30 SW 1st St #1001
                      <br data-id="element-126" />
                      Miami, FL 33132
                    </address>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-127">
                  <PhoneIcon className="w-6 h-6 text-brand-gold mr-4 flex-shrink-0 mt-1" data-id="element-128" />
                  <div data-id="element-129">
                    <h3 className="text-brand-white font-medium mb-1" data-id="element-130">Phone</h3>
                    <a href="tel:786-901-0611" className="text-brand-champagne-light/70 hover:text-brand-gold transition-colors" data-id="element-131">
                      786-901-0611
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-brand-black border border-brand-charcoal p-8 rounded-sm" data-id="element-132">
              <div className="flex items-center mb-6" data-id="element-133">
                <ClockIcon className="w-6 h-6 text-brand-gold mr-3" data-id="element-134" />
                <h3 className="font-heading text-2xl text-brand-white" data-id="element-135">
                  Business Hours
                </h3>
              </div>

              <ul className="space-y-4 text-brand-champagne-light/80" data-id="element-136">
                <li className="flex justify-between items-center border-b border-brand-charcoal pb-4" data-id="element-137">
                  <span data-id="element-138">Monday – Friday</span>
                  <span className="text-brand-white font-medium" data-id="element-139">
                    10:00 AM – 6:00 PM
                  </span>
                </li>
                <li className="flex justify-between items-center border-b border-brand-charcoal pb-4" data-id="element-140">
                  <span data-id="element-141">Saturday</span>
                  <span className="text-brand-white font-medium" data-id="element-142">
                    10:00 AM – 2:00 PM
                  </span>
                </li>
                <li className="flex justify-between items-center pt-2" data-id="element-143">
                  <span data-id="element-144">Sunday</span>
                  <span className="text-brand-gold font-medium" data-id="element-145">Closed</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}